import { handleActions } from 'redux-actions';
import {LOCATION_CHANGE} from 'react-router-redux';
import http from '../../../../modules/shared/http';
import intl from './shared/intl';
import endpoints from '../../../../config/endpoints';

import qs from 'qs';
import _pathOr from 'lodash/fp/pathOr';
import _get from 'lodash/get';
import _path from 'lodash/fp/path';
import _isEmpty from 'lodash/fp/isEmpty';

const INIT_POPUP = 'market/init-popup';
const HIDE_POPUP = 'market/hide-popup';

const SEARCH_GOODS = 'market/search-by-name';
const TOGGLE_CATEGORY_ITEM = 'market/toggle-category-item';
const TOGGLE_ORDER_ITEM = 'market/toggle-order-item';
const TOGGLE_ONLY_AVAILABLE = 'market/toggle-only-available';

const DATA_FETCH_SUCCESS = 'market/data-fetch-success';
const DATA_FETCH_ERROR = 'market/data-fetch-error';
const PAGINATION_SUCCESS = 'market/pagination-success';
const PAGINATION_ERROR = 'market/pagination-error';
const CHANGE_LANGUAGE = 'market/change-language';
const HAMBURGER_CLICK = 'market/hamburger-click';
const LOGOUT_SUCCESS = 'market/logout-success';
const LOGOUT_ERROR = 'market/logout-error';
const ORDER_SUCCESS = 'market/order-success';
const ORDER_FAILED = 'market/order-failed';
const BUTTON_DISABLED = 'market/button-disabled';

const BROWSER_LANG = window.navigator.language.slice(0, 2);
const AVAILABLE_LANGS = ['en', 'ru'];

const checkLanguage = lang => AVAILABLE_LANGS.includes(lang);

export const popupType = {
	confimPopup: 'popup-order-request modal-overlay',
	success: 'popup-order-success modal-overlay',
	error: 'popup-order-fail modal-overlay'
};

const NAV_MENU = [{
	title: 'Webmaster',
	to:'https://rocketprofit.com',
	isLink: false,
	activeClass: ''
}, {
	title: 'Offers',
	to:'https://rocketprofit.com',
	isLink: false,
	activeClass: ''
}, {
	title: 'News',
	to:'https://rocketprofit.com',
	isLink: false,
	activeClass: ''
}, {
	title: 'Events',
	to:'https://rocketprofit.com',
	isLink: false,
	activeClass: ''
}, {
	title: 'Store',
	to:'/market',
	isLink: true,
	activeClass: 'active'
}];

const goodsPaginationLimit = 16;

const initialState = {
	data: null,
	categories: [],
	lang: checkLanguage(BROWSER_LANG) ? BROWSER_LANG : 'en',
	query: {
		search: '',
		filters: {
			categories: []
		},
		sort: []

	},
	pagination: 0,
	error: false,
	popupConditions: { popup_type: popupType.confimPopup, isVisible: false },
	isHamburgerActive: false,
	isOrderButtonDisabled: false
};

export const actions = {
	fetchData: () => (dispatch, getState) => {
		const { query, pagination } = getState().marketMain;
		const params = {
			...query,
			offset: 0,
			limit: goodsPaginationLimit + pagination * goodsPaginationLimit
		};

		return http({
			url: [`${endpoints.MARKET.MAIN}?${qs.stringify(params)}`, endpoints.GOOD_CATEGORIES],
			method: 'get',
			actions: [ DATA_FETCH_SUCCESS, DATA_FETCH_ERROR ]
		})(dispatch);
	},
	toggleCategoryItem: item => (dispatch, getState) => {
		const categories = getState().marketMain.query.filters.categories;

		if (item === 0) {
			dispatch({ type: TOGGLE_CATEGORY_ITEM, payload: [] });
		} else {
			dispatch({
				type: TOGGLE_CATEGORY_ITEM,
				payload: categories.includes(item) ? categories.filter(c => c !== item) : categories.concat(item)
			});
		}

		actions.fetchData()(dispatch, getState);
	},
	toggleOrderItem: (item, direction = 'desc') => (dispatch, getState) => {
		let { sort } = getState().marketMain.query;

		dispatch({
			type: TOGGLE_ORDER_ITEM,
			payload: sort.includes(item) && sort.includes(direction) ? [] : [item, direction]
		});
		actions.fetchData()(dispatch, getState);
	},
	saveUpForGood: good_id => (dispatch, getState) => {
		return http({
			url: `${endpoints.MARKET.SAVEUP_FOR}`,
			method: 'put',
			data: {good_id},
			actions: ['']
		})(dispatch)
			.then(() => actions.fetchData()(dispatch, getState));
	},
	toggleOnlyAvailable: () => (dispatch, getState) => {
		const { contest_points } = getState().marketMain.data.user;

		dispatch({
			type: TOGGLE_ONLY_AVAILABLE,
			payload: contest_points
		});
		actions.fetchData()(dispatch, getState);
	},
	paginateGoods: () => (dispatch, getState) => {
		const goodsRowsLength = selectors.getData(getState()).rows.length || 0;
		const { query } = getState().marketMain;
		return http({
			url: `${endpoints.MARKET.MAIN}?offset=${goodsRowsLength}&limit=${goodsPaginationLimit}&
			${qs.stringify(query)}`,
			method: 'get',
			actions: [ PAGINATION_SUCCESS, PAGINATION_ERROR ]
		})(dispatch);
	},
	handleOrder: order => (dispatch, getState) => {
		const {good, user, marketLang} = order || getState().marketMain.popupConditions;
		if (_isEmpty(user) || user.contest_points < good.price) return false;

		dispatch({ type: BUTTON_DISABLED });

		return http({
			url: `${endpoints.MARKET.ORDER.replace('{id}', good.id)}?lang=${marketLang}`,
			method: 'post',
			actions: [ ORDER_SUCCESS, ORDER_FAILED ]
		})(dispatch)
			.then(() => actions.fetchData()(dispatch, getState));
	},
	initPopup: (good, user, marketLang) => ({
		type: INIT_POPUP,
		payload: { good, user, marketLang }
	}),
	hidePopup: () => ({
		type: HIDE_POPUP
	}),
	searchGoods: searchString => (dispatch, getState) => {
		dispatch({
			type: SEARCH_GOODS,
			payload: searchString
		});
		actions.fetchData()(dispatch, getState);
	},
	logout: () => dispatch => {
		return http({
			url: endpoints.APP.SESSION,
			method: 'delete',
			actions: [LOGOUT_SUCCESS, LOGOUT_ERROR]
		})(dispatch)
			.then(action => {
				if (action.type === LOGOUT_SUCCESS) {
					window.location.reload(true);
				}
			});
	},

	changeLang: lang => ({
		type: CHANGE_LANGUAGE,
		payload: lang
	}),

	handleHamburgerClick: () => ({
		type: HAMBURGER_CLICK
	})

};

const reducers = Object.assign({
	[DATA_FETCH_SUCCESS]: (state, action) => {
		const marketLanguage = _pathOr(state.lang, ['payload', 'data', 'user', 'language'])(action);
		return {
			...state,
			data: action.payload[0].data,
			categories: action.payload[1].data.rows,
			lang: marketLanguage === 'ru' ? 'ru' : 'en'
		};
	},
	[CHANGE_LANGUAGE]: (state, action) => ({
		...state, lang: action.payload
	}),
	[LOCATION_CHANGE]: (state, action) => ({
		...state,
		data: null
	}),
	[TOGGLE_CATEGORY_ITEM]: (state, action) => ({
		...state, 	query: {
			...state.query,
			filters: {
				...state.query.filters,
				categories: action.payload
			}
		}
	}),
	[SEARCH_GOODS]: (state, action) => ({
		...state, query: {...state.query, search: action.payload }
	}),
	[DATA_FETCH_ERROR]: state => {
		return { ...state, error: true };
	},
	[TOGGLE_ORDER_ITEM]: (state, action) => ({
		...state, 	query: {
			...state.query,
			filters: {
				...state.query.filters
			},
			sort: action.payload
		}
	}),
	[TOGGLE_ONLY_AVAILABLE]: (state, action) => {
		const filters = {
			...state.query.filters,
			before_points: action.payload
		};

		if (state.query.filters.before_points >= 0) {
			delete filters.before_points;
		}
		return {
			...state,
			query: {
				...state.query,
				filters
			}
		};
	},
	[PAGINATION_SUCCESS]: (state, action) => {
		return {
			...state,
			data: {
				...state.data,
				rows: [
					...state.data.rows,
					...action.payload.data.rows
				]
			},
			pagination: state.pagination + 1
		};
	},
	[PAGINATION_ERROR]: state => {
		return { ...state, error: true };
	},
	[INIT_POPUP]: (state, action) => {
		return {
			...state,
			popupConditions: {
				...state.popupConditions,
				...action.payload,
				isVisible: true,
				popup_type: popupType.confimPopup
			}
		};
	},
	[HAMBURGER_CLICK]: state => ({
		...state, isHamburgerActive: !state.isHamburgerActive
	}),
	[ORDER_SUCCESS]: (state, action) => {
		const contest_points = _path(['payload', 'data', 'user', 'contest_points'])(action);
		return {
			...state,
			data: {
				...state.data,
				user: {
					..._get(state, 'data.user', {}),
					contest_points
				}
			},
			isOrderButtonDisabled: false,
			popupConditions: {...state.popupConditions, popup_type: popupType.success, isVisible: true}
		};
	},
	[ORDER_FAILED] : state => {
		return {
			...state,
			isOrderButtonDisabled: false,
			popupConditions: {...state.popupConditions, popup_type: popupType.error, isVisible: true}
		};
	},
	[HIDE_POPUP] :  state => {
		return {
			...state,
			popupConditions:  {...state.popupConditions, isVisible: false, popup_type: popupType.confimPopup}};
	},
	[BUTTON_DISABLED]: state => ({ ...state, isOrderButtonDisabled: true })
});

export default handleActions(reducers, initialState);

export const selectors = {
	getData: state => state.marketMain.data,
	getCategories: state => [{ id: 0, name_en: 'All', name_ru: 'Все' }, ...state.marketMain.categories],
	getQuery: state => state.marketMain.query,
	getOnlyAvailable: state => state.marketMain.query.filters.before_points,
	getCurrentLang: state => state.marketMain.lang,
	getAvailableLangs: () => AVAILABLE_LANGS,
	getNavbarMenu: () => NAV_MENU,
	getIntl: state => intl(state.marketMain.lang),
	getIsOrderButtonDisabled: state => state.marketMain.isOrderButtonDisabled,
	getIsHamburgerActive: state => state.marketMain.isHamburgerActive,
	getPopupInfo: state => state.marketMain.popupConditions
};


// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/market/index.js